import { MenuItem } from "@/types/menu";

export const menuData: MenuItem[] = [
  // {
  //   title: "Home",
  //   url: "/",
  // },
  {
    title: "Accounting & Finance Programs",
    url: "/accounting",
    subNav: [
      {
        title: "AI in Accounting - CAIRA",
        url: "/caira",
      },
      {
        title: "U.S. CPA",
        url: "/cpa",
        subItems: [
          {
            title: "CPA Course",
            url: "/cpa/cpa-course",
          },
          // {
          //   title: "CPA Overview",
          //   url: "/cpa/certified-public-accountant-overview",
          // },
          {
            title: "CPA Eligibility",
            url: "/cpa/cpa-eligibility",
          },
          {
            title: "CPA Salary",
            url: "/cpa/cpa-salary",
          },
          {
            title: "CA vs. CPA",
            url: "/cpa/ca-vs-cpa",
          },
          {
            title: "CPA Exam",
            url: "/cpa/cpa-exam",
          },
          {
            title: "CPA Fees",
            url: "/cpa/cpa-fees",
          },
          {
            title: "Miles CPA",
            url: "/cpa/miles-cpa",
          },
        ],
      },
      {
        title: "U.S. CMA",
        url: "/cma",
        subItems: [
          {
            title: "CMA Course",
            url: "/cma/cma-course",
          },
          // {
          //   title: "CMA Overview",
          //   url: "/cma/certified-management-accountant-overview",
          // },
          {
            title: "CMA Eligibility",
            url: "/cma/cma-eligibility",
          },
          {
            title: "CMA Salary",
            url: "/cma/cma-salary",
          },
          {
            title: "CA vs. CMA",
            url: "/cma/ca-vs-cma",
          },
          {
            title: "CMA Exam",
            url: "/cma/cma-exam",
          },
          {
            title: "CMA Fees",
            url: "/cma/cma-fees",
          },
          {
            title: "Miles CMA",
            url: "/cma/miles-cma",
          },
        ],
      },
      {
        title: "U.S. Pathway for Accountants",
        url: "/us-jobs-for-accountants",
      },
      // {
      //   title: "Masterclass (CPE Credits)",
      //   url: "https://www.milesmasterclass.com",
      // },
      {
        title: "U.S. EA (Enrolled Agent)",
        url: "/ea",
      },
      {
        title: "Accounting Jobs",
        url: "/cpa-cma-job-opportunities-india",
      },
      {
        title: "Miles Alumni",
        url: "/cpa-cma-career-success-stories-india",
      },
      {
        title: "Blog",
        url: "/blog",
      },
    ],
  },
  // {
  //   title: "Healthcare",
  //   url: "/healthcare",
  //   subNav: [
  //     {
  //       title: "MBBS-MD U.S. Pathway",
  //       url: "/mbbs",
  //     },
  //     {
  //       title: "U.S. Pathway for Nurses",
  //       url: "/us-jobs-for-nurses",
  //     },
  //   ],
  // },
  // {
  //   title: "Ventures",
  //   url: "/business",
  //   subNav: [
  //     {
  //       title: "SOBA - School of Branding & Advertising",
  //       url: "/school-of-branding-and-advertising",
  //     },
  //     // {
  //     //   title: "MBA Abroad",
  //     //   url: "/mba-abroad",
  //     // },
  //     {
  //       title: "IIM Indore - Branding & Advertising",
  //       url: "/business/post-graduate-certificate-programme-in-branding-and-advertising",
  //     },
  //   ],
  // },
  // {
  //   title: "Resources",
  //   url: "",
  //   subNav: [
  //     {
  //       title: "Blog",
  //       url: "/blog",
  //     },
  //     {
  //       title: "About Us",
  //       url: "/about-us",
  //     },
  //   ],
  // },
  {
    title: "Miles Ecosystem",
    url: "",
    subNav: [
      {
        title: "Miles Masterclass",
        url: "https://www.milesmasterclass.com/accounting/home",
      },
      {
        title: "Miles Talent Hub",
        url: "https://www.milestalenthub.com/",
      },
      // {
      //   title: "Miles Nursing Hub",
      //   url: "https://www.milesnursinghub.com/",
      // },
      {
        title: "Miles Campus",
        url: "https://www.milescampus.ai/",
      },
      {
        title: "Miles Global Education",
        url: "/certifications",
      },
      {
        title: "Futurense Technologies",
        url: "https://futurense.com/",
      },
      {
        title: "Mojo Campus",
        url: "#",
      },
      {
        title: "Miles Foundation",
        url: "/miles-foundation",
      },
      {
        title: "Miles MBBS | Doctors",
        url: "/mbbs",
      },
    ],
  },
  {
    title: "Contact Us",
    url: "/contact-us",
  },
];
